<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('public.research_service.title')  }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
          <span class="middle_loc">{{ $t('public.title')  }} > </span>
          <span class="middle_loc">{{ $t('public.research_service.title')  }} > </span>
          <span class="back_loc">{{ $t('common.button.add') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step02">
              <h2>{{ $t('public.research_service.fields.step_01') }}</h2>
              <p>{{ $t('public.research_service.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="active step_box step03">
              <h2>{{ $t('public.research_service.fields.step_02') }}</h2>
              <p>{{ $t('public.research_service.fields.review_submit') }}</p>
            </v-flex>
            <v-flex class="step_box step04">
              <h2>{{ $t('public.research_service.fields.step_03') }}</h2>
              <p>{{ $t('public.research_service.fields.payment') }}</p>
            </v-flex>
          </v-layout>
          <v-layout column class="ma-0 pos-r center__wrapper mt-30">
            <v-flex class="inner_basic_wrap type2">
              <v-tabs
                v-model="activeTab"
                class="my_app_tabs_data type2"
                hide-slider
                grow
              >
                <v-tab :href="'#tab-1'" class="mw-200">{{ $t('public.research_service.fields.requests') }}</v-tab>
                <v-tab :href="'#tab-2'" class="mw-200">{{ $t('public.research_service.fields.attached_documents') }}</v-tab>

                <v-tab-item :value="`tab-1`">
                  <RequestInformation
                    :receipt_no.sync = receipt_no
                  />

                  <div>
                    <h2 class="m_title">{{ $t('public.research_service.fields.research_types') }}</h2>
                    <v-flex class="item_box bd_none pa-18 pt-0 pb-0">
                      <div class="input_checkbox_type_basic row ma-0">
                        <v-radio-group
                          v-model="research.research_type_code"
                          class="view__radio"
                        >
                          <template v-for="(item, index) in $vuetify.rtl ? researchTypeListAr : researchTypeListEn">
                            <v-radio
                              :label="item.text"
                              :value="item.value"
                              style="height:30px;"
                              :key="index"
                              readonly
                            ></v-radio>
                          </template>
                        </v-radio-group>
                      </div>
                    </v-flex>

                    <v-flex class="item_box bd_none pa-0" v-if="research.research_type_code === '5807'">
                      <div class="pa-18 pt-0">
                        <div class="input_text_type_basic file_type wp50" >
                          <v-chip
                            label
                            dark
                            color="#555"
                            v-if="research.id_card_file_name != ''"
                          >
                            <v-icon>{{fnGetFileIcon(research.id_card_file_ext)}}</v-icon>
                            {{ research.id_card_file_name }}
                          </v-chip>
                        </div>
                      </div>
                    </v-flex>

                    <v-flex class="item_box bd_none">
                      <div class="pb-10">
                        <v-textarea
                          outlined
                          class="br_none mt-15 text_icon_type type2 ie_textarea login_text_field"
                          width="100%"
                          readonly
                          v-model="research.notes"
                        >
                        </v-textarea>
                      </div>
                    </v-flex>
                    <v-flex class="item_box bd_none">
                      <h2 class="m_title">{{ $t('public.research_service.fields.search_scope') }}</h2>
                      <div class="pa-18 pt-0 pb-10">
                        <div class="input_checkbox_type_basic row ma-0">
                          <v-checkbox
                            :label="$t('public.research_service.fields.egyptian_patents')"
                            v-model="research.ind_search_egyptian"
                            value="Y"
                            false-value="N"
                            hide-details
                            readonly
                            class="view__chkbox"
                          ></v-checkbox>
                          <v-spacer class="hidden_lr5"></v-spacer>
                          <v-checkbox
                            :label="$t('public.research_service.fields.foreign_patents')"
                            v-model="research.ind_search_foreign"
                            value="Y"
                            false-value="N"
                            hide-details
                            readonly
                            class="view__chkbox"
                          ></v-checkbox>
                        </div>
                      </div>
                    </v-flex>

                    <v-flex class="item_box d-flex bd_none mb-15 pa-18 pt-0 pb-0">
                      <template v-for="(item, index) in research.research_digital_patents">
                        <v-chip
                          outlined
                          label
                          dark
                          color="#555"
                          :key="index"
                        >{{ item.patent_no + ' (' + item.country_code + ')' }}</v-chip>
                        <v-spacer class="hidden_lr5" :key="index+'_spc'"></v-spacer>
                      </template>
                    </v-flex>

                    <v-flex class="item_box bd_none">
                      <div class="pa-18 pt-0">
                        <div class="input_text_type_basic file_type wp50" >
                          <v-chip
                            label
                            dark
                            color="#555"
                            v-if="research.digital_doc_file_name != ''"
                          >
                            <v-icon>{{fnGetFileIcon(research.digital_doc_file_ext)}}</v-icon>
                            {{ research.digital_doc_file_name }}
                          </v-chip>
                        </div>
                      </div>
                    </v-flex>

                    <v-flex class="item_box bd_none">
                      <h2 class="m_title">{{ $t('public.research_service.fields.required_research_language') }}</h2>
                      <div class="input_checkbox_type_basic row ma-0 pa-20 pt-0">
                        <v-checkbox
                          class="view__chkbox"
                          :label="$t('public.research_service.fields.arabic')"
                          v-model="research.ind_lang_arabic"
                          value="Y"
                          false-value="N"
                          hide-details
                          readonly
                        ></v-checkbox>
                        <v-spacer class="hidden_lr5"></v-spacer>
                        <v-checkbox
                          class="view__chkbox"
                          :label="$t('public.research_service.fields.english')"
                          v-model="research.ind_lang_english"
                          value="Y"
                          false-value="N"
                          hide-details
                          readonly
                        ></v-checkbox>
                        <v-spacer class="hidden_lr5"></v-spacer>
                      </div>
                    </v-flex>

                    <v-flex class="item_box bd_none">
                      <h2 class="m_title">{{ $t('public.research_service.fields.the_purpose_of_the_research') }}</h2>
                      <div class="input_checkbox_type_basic ma-0 pa-18 pt-0 pb-0">
                        <v-checkbox
                          :label="$t('public.research_service.fields.purpose_0')"
                          v-model="research.ind_to_start"
                          value="Y"
                          false-value="N"
                          hide-details
                          readonly
                          class="view__chkbox"
                        ></v-checkbox>
                        <v-spacer class="hidden_lr5"></v-spacer>
                        <v-checkbox
                          :label="$t('public.research_service.fields.purpose_1')"
                          v-model="research.ind_scientific_dissertation"
                          value="Y"
                          false-value="N"
                          hide-details
                          readonly
                          class="view__chkbox"
                        ></v-checkbox>
                        <v-spacer class="hidden_lr5"></v-spacer>
                        <v-checkbox
                          :label="$t('public.research_service.fields.purpose_2')"
                          v-model="research.ind_solve_tech_problem"
                          value="Y"
                          false-value="N"
                          hide-details
                          readonly
                          class="view__chkbox"
                        ></v-checkbox>
                        <v-spacer class="hidden_lr5"></v-spacer>
                        <v-checkbox
                          :label="$t('public.research_service.fields.purpose_3')"
                          v-model="research.ind_feasibility_study"
                          value="Y"
                          false-value="N"
                          hide-details
                          readonly
                          class="view__chkbox"
                        ></v-checkbox>
                        <v-spacer class="hidden_lr5"></v-spacer>
                        <v-checkbox
                          :label="$t('public.research_service.fields.purpose_4')"
                          v-model="research.ind_other"
                          value="Y"
                          false-value="N"
                          hide-details
                          readonly
                          class="view__chkbox"
                        ></v-checkbox>
                      </div>
                      <v-col class="pa-18 pt-0 pb-0" v-if="research.ind_other === 'Y'">
                        <div class="input_text_type_basic mt-15">
                          <v-textarea
                            outlined
                            class="br_none mt-15 text_icon_type type2 ie_textarea login_text_field"
                            width="100%"
                            readonly
                            v-model="research.other_purpose"
                          >
                          </v-textarea>
                        </div>
                      </v-col>
                    </v-flex>
                  </div>


                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>

                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="!contentConfirm"
                          @click.stop="fnConfirmContent()"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn

                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="contentConfirm"
                          @click.stop="fnCancelContent()"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="!confirmYn"
                          @click="fnSubmit()"
                        >
                        <v-icon>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>
                    </div>
                  </div>
                </v-tab-item>

                <v-tab-item :value="`tab-2`">
                  <DocumentViewer
                    :items="documentFileList"
                  />

                   <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>

                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="!docConfirm"
                          @click.stop="fnConfirmDoc()"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="docConfirm"
                          @click.stop="fnCancelDoc()"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="!confirmYn"
                          @click="fnSubmit()"
                        >
                        <v-icon>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>
                    </div>
                  </div>

                </v-tab-item>

              </v-tabs>
            </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DocumentViewer from '@/components/layout/DocumentViewer'
import RequestInformation from '@/views/myrequest/RequestInformation'

export default {
  name: 'ResearchServiceStep2',
  components :{
    DocumentViewer,
    RequestInformation
  },
  data () {
    return {
      activeTab : 'tab-1',
      receipt_no : this.$route.params.receipt_no,
      documentFileList: [],

      docConfirm : false,
      contentConfirm : false,

      researchTypeListAr: [],
      researchTypeListEn: [],
      periodTypeListAr: [],
      periodTypeListEn: [],

      research : {
        company_name_ar : '',
        research_type_code : '',
        ind_search_egyptian : '',
        ind_search_foreign : '',
        digital_doc_file_key : '',
        digital_doc_file_name : '',
        ind_lang_arabic: '',
        ind_lang_english : '',
        ind_lang_french : '',
        ind_lang_german : '',
        ind_lang_other : '',
        other_language : '',
        search_period_type_code : '',
        ind_to_start : '',
        ind_scientific_dissertation : '',
        ind_solve_tech_problem : '',
        ind_feasibility_study : '',
        ind_other : '',
        other_purpose : '',
        notes: '',
        research_digital_patents : [],
        id_card_file_key: '',
        id_card_file_name: '',
        id_card_file_ext: ''
      }
    }
  },
  computed : {
    confirmYn (){
      return this.docConfirm && this.contentConfirm
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnInit()

    // 푸터 여백 처리
    document.querySelectorAll('.copyright_wrap')[0].classList.add('mb-45')
  },
  methods: {
    fnInit(){
      let options = {
        upper_code: '5800'
      }
      utils.fnGetCodeList(options).then(list => {
        this.researchTypeListAr = list.ar
        this.researchTypeListEn = list.en
        this.research.research_type_code = this.researchTypeListAr[0].value
      })

      options = {
        upper_code: '5900'
      }
      utils.fnGetCodeList(options).then(list => {
        this.periodTypeListAr = list.ar
        this.periodTypeListEn = list.en
        this.research.search_period_type_code = this.periodTypeListAr[0].value
      })

      this.fnGetContent()
      this.fnGetResearchService()
      this.fnGetDocumentFileList()
    },
    fnGetResearchService(){
      requestApi({
        url: '/receivings/research/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.research.company_name_en             = res.data.company_name_en
            this.research.company_name_ar             = res.data.company_name_ar
            this.research.ind_search_egyptian         = res.data.ind_search_egyptian
            this.research.ind_search_foreign          = res.data.ind_search_foreign
            this.research.digital_doc_file_key        = res.data.digital_doc_file_key
            this.research.digital_doc_file_name       = res.data.digital_doc_file_name
            this.research.digital_doc_file_ext       = res.data.digital_doc_file_ext
            this.research.ind_lang_arabic = res.data.ind_lang_arabic
            this.research.ind_lang_english            = res.data.ind_lang_english
            this.research.ind_lang_french             = res.data.ind_lang_french
            this.research.ind_lang_german             = res.data.ind_lang_german
            this.research.ind_lang_other              = res.data.ind_lang_other
            this.research.other_language              = res.data.other_language
            this.research.ind_to_start                = res.data.ind_to_start
            this.research.ind_scientific_dissertation = res.data.ind_scientific_dissertation
            this.research.ind_solve_tech_problem      = res.data.ind_solve_tech_problem
            this.research.ind_feasibility_study       = res.data.ind_feasibility_study
            this.research.ind_other                   = res.data.ind_other
            this.research.other_purpose               = res.data.other_purpose
            this.research.notes = res.data.notes
            this.research.research_digital_patents    = res.data.research_digital_patents
            this.research.id_card_file_key = res.data.id_card_file_key
            this.research.id_card_file_name = res.data.id_card_file_name
            this.research.id_card_file_ext = res.data.id_card_file_ext

            this.research.research_type_code          = res.data.research_type_code
            this.research.search_period_type_code     = res.data.search_period_type_code
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetResearchService()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnConfirmDoc(){
      let params = {
        ind_attached_confirm : 'Y'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.docConfirm = true

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmDoc()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCancelDoc(){
      let params = {
        ind_attached_confirm : 'N'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.cancel_confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.docConfirm = false
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnCancelDoc()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnConfirmContent(){
      let params = {
        request_content_confirm : 'Y'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.contentConfirm = true
            this.activeTab = 'tab-2'

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCancelContent(){
      let params = {
        request_content_confirm : 'N'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.cancel_confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.contentConfirm = false

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnCancelContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGoBefore(){
      this.$router.push({path:'/public/research/step1/' + this.receipt_no})
    },

    fnSubmit(){
      requestApi({
        url: '/receivings/research/' + this.receipt_no + '/submit',
        method: 'PUT',
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.$router.push({path : '/public/research/step3/'+this.receipt_no})
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmit()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetContent(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.docConfirm = res.data.ind_attached_confirm === 'Y'
            this.contentConfirm = res.data.request_content_confirm === 'Y'

            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6417'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetFileIcon(file_ext) {
      return utils.getExtIcon(file_ext)
    }
  }
}
</script>